<template>
    <div class="Modifier-Row">
      <div class="Modifier-Title">
        <div>
          <input type="checkbox" v-model="localActive" v-if="!modifier.group">
          <input type="checkbox" v-model="localActiveSelect" v-if="modifier.group">
        </div>
        <span>{{ modifier.group || modifier.name }}</span>
        <select v-if="modifier.group" v-model="selected" v-show="localActiveSelect">
            <option value="" :disabled="selected === ''"></option>
            <option :value="modifier.index" >{{ modifier.name }}</option>
            <option v-for="item in modifier.partners" :value="item.index">{{ item.name }}</option>
        </select>
      </div>
      <div class="Modifier-Amount">
            {{ type === 'FIXED_DECREASE' ? '-' : '' }}
            {{ amount | formatCurrency(active_module.currency) }}
      </div>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    props: ['modifier', 'modifiers'],

    data () {
      return {
        selected: '',
        active: false,
        activeSelect: false
      };
    },

    computed: {
      ...mapGetters([
        'active_module',
      ]),

      type () {
        if (this.modifier.group) {
          if (this.selected !== '') {
            return this.modifiers[this.selected].type;
          }
          return '';
        }

        return this.modifier.type;
      },

      amount () {
        if (this.modifier.group) {
          if (this.selected !== '') {
            return this.modifiers[this.selected].amount;
          }
          return 0;
        }

        return this.modifier.amount;
      },

      localActive: {
        get () {
          return this.active;
        },

        set (val) {
          // console.log('checkbox', val);
          this.$emit('change', this.modifier.index, val);
          this.active = val;
        }
      },

      localActiveSelect: {
        get () {
          return this.activeSelect;
        },

        set (val) {
          // console.log('select', val);
          if (!val) this.selected = '';
          this.activeSelect = val;
        }
      }
    },

    watch: {
      'selected': function (val, oldVal) {
        if (oldVal !== '') {
          this.$emit('change', oldVal, false);
        }
        if (val !== '') {
          this.$emit('change', val, true);
        }
      }
    }
  };
</script>

<style scoped>
  .Modifier-Row {
    display: flex;
    justify-content: space-between;
    margin: 2.2% 0;
    color: #737373;
    line-height: 1.6;
  }

  .Modifier-Title, .Modifier-Title > span {
    max-width: 90%;
  }

  .Modifier-Title, .Modifier-Amount {
    font-family: 'Roboto';
    font-size: 1.12em;
    display: flex;
  }

  select {
    border: 1px solid #737373;
  }

  .Modifier-Title {
    font-weight: 300;
  }

  .Modifier-Amount {
    font-weight: 600;
  }

  .Modifier-Title input[type=checkbox], .Modifier-Title span {
    margin-right: 12px;
  }
</style>



// WEBPACK FOOTER //
// modifier-row.vue?c0fc4724